<template>
  <b-modal
      id="modal-info-produto-id-new"
      title="Informações do Produto"
      ref="refModalInfoProduto"
      size="xl"
      no-close-on-esc
      hide-header
      no-close-on-backdrop
  >
    <template #modal-footer>
      <div style="display: flex;gap: 10px">
        <div>
          <b-button
              variant="danger"
              @click="onCancelModal"
          >
            <feather-icon icon="XIcon" class="mr-50"/>
            Cancelar
          </b-button>
        </div>
        <div>
          <b-button
              variant="success"
              @click="adicionarCarrinho"
          >
            <feather-icon icon="ShoppingCartIcon" class="mr-50"/>
            Adicionar
          </b-button>
        </div>
      </div>
    </template>
    <e-commerce-product-details />
    <b-modal
        id="modal-gallery-imagens"
        hide-footer
        hide-header
        style="height: 500px; width: 100%;background: transparent; border: none; padding: 0; margin: 0;"
        body-bg-variant="transparent"
    >
      <swiper
          ref="refSwiperGallery"
          class="swiper-gallery gallery-top"
          :options="swiperOptions"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      >
        <swiper-slide
            v-for="(data,index) in item.imagens"
            :key="index"
        >
          <b-img
              :src="data.caminho"
              fluid
          />
        </swiper-slide>

        <div
            slot="button-next"
            class="swiper-button-next swiper-button-white"
        />
        <div
            slot="button-prev"
            class="swiper-button-prev swiper-button-white"
        />
      </swiper>
    </b-modal>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { formtPriceBr } from '@core/utils/filter';
import 'swiper/css/swiper.css';
import GradeItem from '@/components/catalogo-produtos/GradeItem.vue';
import ECommerceProductDetails from '@/views/app/CartECommerce/e-commerce-product-details/ECommerceProductDetails.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

export default {
  name: 'ModalInfoProduto',
  components: {
    ECommerceProductDetails,
    GradeItem,
    Swiper,
    SwiperSlide,
  },
  filters: {
    formtPriceBr,
  },
  data() {
    return {
      tabActive: 0,
      showModal: true,
      slide: 0,
      imagemPadrao: IMAGEM_PADRAO,
      mainImg: IMAGEM_PADRAO,
      swiperOptions: {
        loop: true,
        loopedSlides: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      itemsCarrinho: [],
      items: [{
        id: 1,
        selected: 'male',
        selected1: 'designer',
        prevHeight: 0,
      }],
    };
  },
  computed: {
    ...mapGetters('ItemStore', {
      item: 'GET_CURRENT_ITEM',
    }),
    ...mapGetters('slsEmbalagem', {
      currentEmbalagem: 'getCurrentEsEmbalag',
    }),
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    updatedGrade(value) {
      this.itemsCarrinho = value.map((item) => {
        // const imagem = this.item.imagens.find(img => img.cdnCor === item.cdn_cor)
        const imagemPrincipal = this.item.imagens.find((item) => item.imagemPrincipal === 1);
        const caminhoImagemPrincipal = imagemPrincipal ? imagemPrincipal.caminho : null;
        this.$store.commit('PedidosStore/ADD_OR_UPDATE_PRODUCT_ITEM_PEDIDO', {
          cod_marca: this.item.cod_marca,
          familia_comercial_id: this.item.referencia,
          cdn_cor: item.cdn_cor,
          cdn_tamanho: item.cdn_tamanho,
          des_tamanho: item.tamanho,
          des_cor: item.des_cor,
          item_id: this.item.item_id,
          item_descricao: `${this.item.referencia} - ${this.item.item_name}`,
          // item_imagem: imagem ? imagem.caminho : 'https://dkpsales-novo-hanes.s3.amazonaws.com/images/images/produto-sem-imagem.png',
          item_imagem: caminhoImagemPrincipal,
          pedido_item_seq: 0,
          pic_id: 0,
          marca: this.item.item_marca,
          embalagem: this.currentEmbalagem.des_embalag,
          cdn_embalag: this.currentEmbalagem.cdn_embalag,
          pedido_item_preco_unitario: parseFloat(this.item.item_price_exibicao ?? this.item.item_price),
          pedido_item_preco_unitario_base: parseFloat(this.item.item_price_base ?? this.item.item_price),
          pedido_item_quantidade: parseInt(item.valor, 10),
          valor_total: +(parseFloat((this.item.item_price_exibicao ?? this.item.item_price)) * parseFloat(item.valor)),
        });
        return {
          cod_marca: this.item.cod_marca,
          familia_comercial_id: this.item.referencia,
          cdn_cor: item.cdn_cor,
          des_cor: item.des_cor,
          cdn_tamanho: item.cdn_tamanho,
          des_tamanho: item.tamanho,
          item_id: this.item.item_id,
          item_descricao: `${this.item.referencia} - ${this.item.item_name}`,
          item_imagem: imagem ? imagem.caminho : IMAGEM_PADRAO,
          pedido_item_seq: 0,
          pic_id: 0,
          marca: this.item.item_marca,
          embalagem: this.currentEmbalagem.des_embalag,
          cdn_embalag: this.currentEmbalagem.cdn_embalag,
          pedido_item_preco_unitario: parseFloat(this.item.item_price_exibicao ?? this.item.item_price),
          pedido_item_preco_unitario_base: parseFloat(this.item.item_price_base ?? this.item.item_price),
          pedido_item_quantidade: parseInt(item.valor, 10),
          valor_total: +(parseFloat((this.item.item_price_exibicao ?? this.item.item_price)) * parseFloat(item.valor)),
        };
      });
    },
    onCancelModal() {
      this.mainImg = IMAGEM_PADRAO;
      this.$refs.refModalInfoProduto.hide();
    },
    adicionarCarrinho() {
      this.$store.commit('ECommercerStore/ADD_OR_UPDATE_PRODUCT_TO_CART', {
        ...this.item,
        item_price: parseFloat(this.item.item_price),
        quantidade: 1,
      });
      this.$refs.refModalInfoProduto.hide();
    },
    openModal(startIndex) {
      this.showModal = true;
      // this.$refs.refSwiperGallery.$forceUpdate()
      this.$bvModal.show('modal-gallery-imagens');
      // this.$nextTick(() => {
      //   this.$refs.swiperTop.$swiper.slideTo(startIndex);
      // });
    },
  },

  mounted() {
    this.mainImg = this.item.imagens[0]?.caminho ?? IMAGEM_PADRAO;
  },
};
</script>

<style scoped>
.destaque {
  border: 1px solid red;
}

/* .imagens-container reservado */

.imagens-item-img {
  border: 1px solid var(--primary);
  width: 50px;
  height: 50px;
}

.imagens-item-img img {
  height: 50px;
}

.imagens-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .imagens-container {
    width: 100%;
    padding-bottom: 10px;
  }

  .imagens-item {
    flex-direction: row;
  }

  /* tamanhos de imagem controlados externamente */
}

/* Estilize a modal e o swiper conforme necessário */
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
</style>
